import {
  ContentLibraryFileEntry,
  ContentLibraryOpenedFile,
  ContentLibrarySharedFile,
} from 'features/content-library/types';

export const isPrivateWhiteboard = (
  file: ContentLibraryOpenedFile | ContentLibraryFileEntry | ContentLibrarySharedFile | null
) => !!file && 'private' in file && !!file.private;
